import CountryFlagIcon from '@liquidweb-dev/undercurrent/icons/hatScripts/CountryFlag';
import { type CountryFlagProps as UCCountryFlagProps } from '@liquidweb-dev/undercurrent/types/svgTypes';

const COUNTRY_CODE_MAP = {
	AUSTRALIA: 'au',
	NETHERLANDS: 'nl',
	'UNITED KINGDOM': 'gb',
	'UNITED STATES': 'us',
} as const;

const isSupportedCountry = (
	country: string,
): country is keyof typeof COUNTRY_CODE_MAP => {
	return country in COUNTRY_CODE_MAP;
};

export interface CountryFlagProps
	extends Omit<UCCountryFlagProps, 'countryCode'> {
	country?: string;
}

const CountryFlag = ({ country, ...rest }: CountryFlagProps) => {
	const countryUpperCase = country?.toUpperCase();

	if (!countryUpperCase) return null;
	if (!isSupportedCountry(countryUpperCase)) return null;

	return (
		<CountryFlagIcon
			countryCode={COUNTRY_CODE_MAP[countryUpperCase]}
			{...rest}
		/>
	);
};

export default CountryFlag;
